<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
      <simple-wizard :is-modal="true" :is-edit="isEdit" :go-next="goNext" @close="handleClose">
        <template slot="header">
          <!-- <h3 class="title" style="line-height: 12px">
            {{ isEdit ? "Edit Reader" : "Register With GlobeChek" }}
          </h3> -->
          <h5 class="category">
            <span style="font-weight: 500; color: #1f5aff">Globe</span>
            <span style="font-weight: 700; color: #555">Chek</span>&nbsp;
            <span style="font-weight: 400; color: 222">
              {{ isEdit ? "Edit Reader Details" : "Reader Registration" }}
            </span>
            <hr style="margin-top: 20px" />
          </h5>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            {{ isEdit ? "Edit Personal Details" : "Personal Details" }}
          </template>
          <first-step ref="step1" :is-edit="isEdit" @on-validated="onStepValidated" @complete="nextTab" />
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">
            {{ isEdit ? "Edit Credentials Details" : "Credentials Details" }}
          </template>
          <second-step ref="step2" :is-edit="isEdit" @on-validated="onStepValidated" @complete="nextTab" />
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">
            {{ isEdit ? "Edit Address Details" : "Address Details" }}
          </template>
          <third-step ref="step3" :is-edit="isEdit" @on-validated="wizardComplete" />
        </wizard-tab>
      </simple-wizard>
    </div>
    <ChooseOrganizationModal v-if="isOrganizationModalOpen" :is-open="isOrganizationModalOpen"
      @cancel="closeOrganizationModal" @save="handleOrganizationSelected" />
  </div>
</template>
<script>
import FirstStep from "./Wizard/Reader_Registration/1_PersonalDetails.vue"
import SecondStep from "./Wizard/Reader_Registration/2_Credentials.vue"
import ThirdStep from "./Wizard/Reader_Registration/3_AddressDetails.vue"
import { SimpleWizard, WizardTab } from "@/components"
import Swal from "sweetalert2"
import { mapGetters, mapActions } from "vuex"
import ChooseOrganizationModal from "@/components/modals/ChooseOrgModal.vue"

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab,
    ChooseOrganizationModal
  },
  props: {
    reader: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wizardModel: {},
      goNext: false,
      isOrganizationModalOpen: false,
      selectedOrganization: null,
    }
  },
  watch: {},
  computed: {
    ...mapGetters(["readerReg", "drEditInfe"]),
    isPhone() {
      if (window.screen.width < 760) {
        return true
      } else {
        return false
      }
    },
    screenWidth() {
      return window.screen.width
    }
  },
  methods: {
    ...mapActions(["addReader", "updateReader"]),
    formatDate(dateObj) {
      if (!dateObj) return null // Handle null or undefined date
      if (!(dateObj instanceof Date)) return dateObj // Ensure valid Date object

      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, "0") // Months are zero-based
      const day = String(dateObj.getDate()).padStart(2, "0")

      return `${year}-${month}-${day}`
    },
    handleOrganizationSelected(organization) {
      this.selectedOrganization = organization
      this.isOrganizationModalOpen = false
      this.saveReader()
    },
    definePayload() {
      const data = this.readerReg
      let orgIds = this.selectedOrganization

      const payload = {
        id: data.editInfo.readerID || "",
        practice: data.credentials.practice || "",
        insurance: data.credentials.insurance.toString() || "",
        otherInsurance: data.credentials.otherInsurance || "",
        boardCertificate: data.credentials.ruCertified || "",
        caqh: data.credentials.CAQH || "",
        npi: data.credentials.NPI || "",
        license: data.credentials.license || "",
        webSite: data.billingAddress.website || null,
        certificationDate: this.formatDate(data.credentials.certDate),
        businessPhoneNo: data.billingAddress.businessPhone || null,
        contactPhoneNo: data.mailingAddress.phone || null,
        isReader: true,
        userType: "Reader", // Assuming a default value
        userId: data.editInfo.doctorID || "",
        isApproved: false, // Defaulting to false; update based on logic
        regions: [796],
        organisations: orgIds,
        mailingAddress: {
          id: data.mailingAddress.id || "",
          address1: data.mailingAddress.address1 || "",
          address2: data.mailingAddress.address2 || null,
          city: data.mailingAddress.city || "",
          state: data.mailingAddress.state.toString() || "",
          country: data.mailingAddress.country.toString() || "",
          zipCode: data.mailingAddress.zipCode || ""
        },
        businessAddress: {
          id: data.billingAddress.id || "",
          address1: data.billingAddress.address1 || "",
          address2: data.billingAddress.address2 || null,
          city: data.billingAddress.city || "",
          state: data.billingAddress.state.toString() || "",
          country: data.billingAddress.country.toString() || "",
          zipCode: data.billingAddress.zipCode || ""
        },
        person: {
          id: data.editInfo.personID || "",
          firstName: data.personal.firstName || "",
          lastName: data.personal.lastName || "",
          email: data.personal.email || "",
          cellNumber: data.personal.cellNumber || "",
          DOB: this.formatDate(data.personal.DOB),
          isActive: true,
          comments: "",
          languages: data.personal.languages.toString() || "",
          gender: data.personal.gender || "",
          allowSMS: data.personal.allowSMS || false
        },
        status: 2
      }

      return payload
    },

    nextTab() {
      this.goNext = true
      this.$nextTick(() => {
        this.goNext = false
      })
    },
    validateStep(ref) {
      return this.$refs[ref].validate()
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model }
    },
    async saveReader() {
      const payload = this.definePayload()
      try {
        if (this.isEdit) {
          await this.updateReader({ readerId: this.readerReg.editInfo.readerID, reader: payload })

          Swal.fire({
            title: "Success",
            text: "Reader updated successfully",
            confirmButtonText: "OK"
          }).then(() => {
            this.$emit("close", true)
          })
        } else {
          await this.addReader(payload)
          Swal.fire({
            title: "Success",
            text: "Reader added successfully",
            confirmButtonText: "OK"
          }).then(() => {
            this.$emit("close", true)
          })
        }
      } catch (error) {
        const errorMsg = error.message || "An error occurred while adding the reader"
        Swal.fire({
          title: "Error",
          text: errorMsg,
          confirmButtonText: "OK"
        })
      }
    },
    wizardComplete() {
      const orgsData = sessionStorage.getItem("organizations")
      if (this.isEdit) {
        this.selectedOrganization = this.readerReg.editInfo.organisations
        this.saveReader()
      } else {
        const organizations = JSON.parse(orgsData)
        if (organizations.length > 1) {
          this.isOrganizationModalOpen = true
          return
        } else if (organizations.length === 1) {
          this.selectedOrganization = [organizations[0].orgId]
          this.saveReader()

        } else {
          Swal.fire({
            title: "Error!",
            text: "No organizations available.",
            icon: "error"
          })
          return
        }
      }
    },
    handleClose() {
      this.$emit("close", false)
    },
    closeOrganizationModal() {
      this.isOrganizationModalOpen = false
    },
  }
}
</script>

<style>
.swal2-container {
  z-index: 10000;
}
</style>
